module.exports = __webpack_public_path__ + "img/acediamonds.b842215d.png";